// simple animation that fades the entire
// elm in then subsequently animates any item that
// have data-animate attr

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
const lib = require('../library')
import { CSSPlugin } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger, CSSPlugin)

export default class AnimationSimpleIn {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.elmsAni = this.el.querySelectorAll('[data-animate]')
    this.motion = lib.userMotionEnabled()
  }

  init() {
    if (this.motion) {
      this.handleScrollAnimation()
    }
  }

  hide() {
    this.elmsAni.forEach((element) => {
      gsap.set(element, { autoAlpha: 0 })
    })
  }

  animateFrom(direction) {
    direction |= 1
    const x = 0
    const y = direction * 75
    gsap.fromTo(this.elmsAni, { x, y, autoAlpha: 0 }, {
      duration: 1,
      stagger: 0.05,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: 'expo',
      overwrite: 'auto',
    })
  }

  // initial animation tied to scrolling
  handleScrollAnimation() {
    this.hide()
    ScrollTrigger.create({
      trigger: this.el,
      once: true,
      onEnter: () =>
        this.animateFrom(),
    })
  }
}
